/* eslint-disable radix, no-plusplus, @typescript-eslint/ban-ts-comment */
// @ts-nocheck

export const cpfMask = (value: string): string => {
  if (!value) return '';

  return `${value}`
    .replace(/\D/g, '') // substitui qualquer caracter que nao seja numero por nada
    .replace(/(\d{3})(\d)/, '$1.$2') // captura 2 grupos de numero o primeiro de 3 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de numero
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1'); // captura 2 numeros seguidos de um traço e não deixa ser digitado mais nada
};

export const dateMask = (value: string): string => {
  if (!value) return '';

  return `${value}`
    .replace(/\D/g, '') // substitui qualquer caracter que nao seja numero por nada
    .replace(/(\d{2})(\d)/, '$1/$2') // captura 2 grupos de numero o primeiro de 3 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de numero
    .replace(/(\d{2})(\d)/, '$1/$2')
    .replace(/(-\d{4})\d+?$/, '$1'); // captura 2 numeros seguidos de um traço e não deixa ser digitado mais nada
};

export const phoneMask = (value: string): string => {
  if (!value) return '';

  const phone = `${value}`
    .replace(/\D/g, '') // substitui qualquer caracter que nao seja numero por nada
    .replace(/(\d{2})(\d)/, '($1) $2'); // captura 2 grupos de numero o primeiro de 3 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de numero

  if (`${value}`.replace(/\D/g, '').length <= 10) {
    return phone.replace(/(\d{4})(\d)/, '$1-$2');
  }
  return `${value}`.replace(/(\d{5})(\d)/, '$1-$2');
};

export const cellPhoneMask = (value: string): string => {
  if (!value) return '';

  const phone = `${value}`
    .replace(/\D/g, '') // substitui qualquer caracter que nao seja numero por nada
    .replace(/(\d{2})(\d)/, '($1) $2'); // captura 2 grupos de numero o primeiro de 3 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de numero

  if (`${value}`.replace(/\D/g, '').length <= 10) {
    return phone.replace(/(\d{4})(\d)/, '$1-$2');
  }

  return `${value}`.replace(/(\d{5})(\d)/, '$1-$2');
};

export const cepMask = (value: string): string => {
  return value
    ? `${value}`
        .replace(/\D/g, '') // substitui qualquer caracter que nao seja numero por nada
        .replace(/(\d{5})(\d)/, '$1-$2')
    : ''; // captura 2 grupos de numero o primeiro de 3 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de numero
};

export const testCpf = (receivedCpf: string): boolean => {
  try {
    const cpf = receivedCpf.replace(/[^\d]+/g, '');
    let numeros;
    let digitos;
    let soma;
    let i;
    let resultado;
    let digitos_iguais;
    digitos_iguais = 1;
    if (cpf.length !== 11) return false;
    for (i = 0; i < cpf.length - 1; i++) {
      if (cpf.charAt(i) !== cpf.charAt(i + 1)) {
        digitos_iguais = 0;
        break;
      }
    }
    if (!digitos_iguais) {
      numeros = cpf.substring(0, 9);
      digitos = cpf.substring(9);
      soma = 0;
      for (i = 10; i > 1; i--) soma += numeros.charAt(10 - i) * i;
      resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
      if (resultado !== parseInt(digitos.charAt(0))) return false;
      numeros = cpf.substring(0, 10);
      soma = 0;
      for (i = 11; i > 1; i--) soma += numeros.charAt(11 - i) * i;
      resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
      return resultado === parseInt(digitos.charAt(1));
    }
    return false;
  } catch (e) {
    return false;
  }
};

export const splitName = (
  fullname: string
): { lastName: string; middleName: string; firstName: string } => {
  const parts = fullname.split(' ');
  const firstName = `${parts.shift()}`;
  const lastName = `${parts.pop()}`;
  const middleName = `${parts.join(' ')}`;

  return {
    firstName,
    lastName,
    middleName,
  };
};
